var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutubeIconCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 20,
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_32051_3276)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.6506 3.12306C26.3469 1.89371 25.4523 0.925644 24.316 0.597096C22.2569 -3.84545e-08 13.9997 0 13.9997 0C13.9997 0 5.74237 -3.84545e-08 3.68319 0.597096C2.547 0.925644 1.65221 1.89371 1.34854 3.12306C0.796875 5.35112 0.796875 9.99998 0.796875 9.99998C0.796875 9.99998 0.796875 14.6487 1.34854 16.8771C1.65221 18.1063 2.547 19.0744 3.68319 19.4031C5.74237 20 13.9997 20 13.9997 20C13.9997 20 22.2569 20 24.316 19.4031C25.4523 19.0744 26.3469 18.1063 26.6506 16.8771C27.2024 14.6487 27.2024 9.99998 27.2024 9.99998C27.2024 9.99998 27.2024 5.35112 26.6506 3.12306Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2988 14.2166L18.2003 9.99599L11.2988 5.77502V14.2166Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_32051_3276"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.4055,
    height: 20,
    fill: "white",
    transform: "translate(0.796875)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeIconCircle);
export default __webpack_public_path__ + "static/media/youtubeIconCircle.b7c6f0276e764007b0f2b12f04313493.svg";
export { ForwardRef as ReactComponent };